export default "__VITE_ASSET__DujAGh3O__"